import { Injectable, inject } from '@angular/core';
import { PageDataService } from '../core/page-data.service';

export type ThemeListKey = 'sellers'|'feeds'|'collection';
export type ThemeListMode = 'infinite'|'pagination';
export interface ThemeListExperience { mode:ThemeListMode; pageSize:number }

interface ThemePayload {
  experience?: { lists?: Partial<Record<ThemeListKey,{mode?:ThemeListMode;pageSize?:number}>> };
}

@Injectable({providedIn:'root'})
export class ThemeListExperienceService {
  private readonly pageData=inject(PageDataService);

  get(key:ThemeListKey):ThemeListExperience {
    const render=this.pageData.get<ThemePayload>('themeRender');
    const presentation=this.pageData.get<ThemePayload>('themePresentation');
    const configured=(render?.experience?.lists??presentation?.experience?.lists)?.[key];
    const pageSize=Math.max(4,Math.min(48,Number(configured?.pageSize??12)||12));
    return {mode:configured?.mode==='pagination'?'pagination':'infinite',pageSize};
  }
}
